<tr
  class="row-body"
  *ngIf="!parent?.children || (parent?.children && parent?.childrenActive)"
  [ngClass]="{
    active: row.childrenActive,
    parent: row.children,
    child: child,
    'child-row-active': parent?.childrenActive,
  }"
>
  <ng-container *ngFor="let column of data.columns; let index = index; trackBy: trackByColumnId">
    <!-- Single Column or multiple columns combined-->
    <ng-container *ngIf="!column.children || (column.children && !column.childrenActive && !column.disabled)">
      <app-basic-cell
        [column]="column"
        [row]="row"
        [disabled]="disabled"
        [ignoreReadOnly]="ignoreReadOnly"
        [index]="index"
        [ngClass]="{ 'cell-inactive': column.childrenActive }"
      ></app-basic-cell>
    </ng-container>

    <!-- Multiple columns -->
    <ng-container *ngIf="column.children && column.childrenActive && !column.disabled">
      <ng-container *ngFor="let childColumn of column.children; trackBy: trackByColumnId">
        <app-basic-cell
          [column]="childColumn"
          [disabled]="disabled"
          [ignoreReadOnly]="ignoreReadOnly"
          [parent]="column"
          [row]="row"
        ></app-basic-cell>
      </ng-container>
    </ng-container>
  </ng-container>
</tr>
